import React from 'react'
import useTranslation from '../../../../../../i18n/useTranslation'

const EducatorObservationsFrecuency = (props) => {
  const { user = {} } = props
  const { translate } = useTranslation()
  const frecuencyList = {
    weekly: translate('profile.actions.frecuency.weekly'),
    beweekly: translate('profile.actions.frecuency.beweekly'),
    monthly: translate('profile.actions.frecuency.monthly'),
    quarterly: translate('profile.actions.frecuency.quarterly'),
    never: translate('profile.actions.frecuency.never'),
  };

  const frecuencyTranslated =
    frecuencyList[user?.educatorInfo?.frecuencyObservations] || '-';


  return (
    <div className="d-flex flex-column mt-3">
      <div className="d-flex flex-row justify-content-between">
        <span className="text-title">{translate('profile.actions.educatorInfo.frecuencyTitle')}</span>
        <div>
          <span className="text-gray mr-2">
            {/* {formatFrecuency(user?.educatorInfo?.frecuencyObservations)} */}
            {frecuencyTranslated}
          </span>
        </div>
      </div>

      <div className="d-flex flex-row justify-content-between mt-2 borderTop">
        <span className="text-title mt-3">
          {translate('profile.actions.educatorInfo.staffObserver')}
        </span>
        <div className="mt-3">
          <span className="text-gray mr-2">
            {user?.educatorInfo?.observationsBy?.staffName || '-'}
          </span>
        </div>
      </div>

    </div>


  )
}

export default EducatorObservationsFrecuency